import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

export const InstagramCTA = () => {
  return (
    <section
      data-testid="instagram-cta"
      className="relative py-20 lg:py-24 bg-gradient-to-br from-[#7AB8D6] via-[#A8D5E5] to-[#F1E4C9] overflow-hidden"
    >
      {/* Soft decorative blobs */}
      <div className="absolute -top-10 -left-10 w-[40vmin] h-[40vmin] rounded-full bg-white/30 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-10 right-10 w-[35vmin] h-[35vmin] rounded-full bg-[#A0522D]/15 blur-3xl pointer-events-none" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8 }}
        className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center"
      >
        <Instagram
          size={40}
          className="mx-auto text-[#2A1810] mb-6"
          strokeWidth={1.5}
        />
        <p className="overline text-[#2A1810]/70 mb-4">Resta connesso</p>
        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2A1810] leading-[1.05]">
          Seguimi su Instagram
          <br />
          <span className="font-serif-italic text-[#A0522D]">
            @mantelheelsexperience
          </span>
        </h2>
        <p className="mt-6 text-[#2A1810]/75 text-base sm:text-lg max-w-xl mx-auto leading-relaxed">
          Dietro le quinte, anticipazioni dei prossimi appuntamenti e tanta
          ispirazione dal mondo dell&apos;Heels Dance.
        </p>
        <a
          href="https://www.instagram.com/mantelheelsexperience/"
          target="_blank"
          rel="noreferrer"
          data-testid="instagram-cta-btn"
          className="inline-flex items-center gap-2 mt-10 px-8 py-3.5 bg-[#2A1810] text-[#FBF6EA] rounded-full text-xs tracking-[0.15em] uppercase font-medium hover:bg-[#A0522D] transition-all hover:shadow-[0_14px_30px_-10px_rgba(42,24,16,0.5)]"
        >
          <Instagram size={16} />
          Vai al profilo
        </a>
      </motion.div>
    </section>
  );
};
